import React from "react";
import { FormattedMessage } from "react-intl";
import { Typography, Table } from "antd";
import { useIntl } from "react-intl";
import Employee from "../../../components/tables/Employee";
import IdOrPassport from "../../../components/tables/IdOrPassport";
import Address from "../../../components/tables/Address";
import Date from "../../../components/tables/Date";
import moment from "moment";
var flatten = require("flat");

const { Title, Text } = Typography;
const Plan = (props) => {
  const { order } = props;
  const intl = useIntl();
  let sorted =
    order && order.recurrent_work_events
      ? order.recurrent_work_events.map((obj, index) => ({
          ...obj,
          key: index,
        }))
      : [];
  sorted.sort((a, b) => a.weekday - b.weekday);
  const sum = sorted.reduce((a, b) => a + (b["duration_minutes"] || 0), 0);
  sorted.push({
    duration_minutes: sum,
    key: sorted.length,
  });
  const columns = [
    {
      title: intl.formatMessage({
        id: "app.plans.employee",
      }),
      dataIndex: "employee",
      render(text, record) {
        return record && record.employee ? (
          <Employee record={record.employee} />
        ) : null;
      },
      ellipsis: true,
      width: "170px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.idOrPassport",
      }),
      render(text, record) {
        return record && record.employee ? (
          <IdOrPassport
            record={flatten(record.employee, {
              safe: true,
            })}
          />
        ) : null;
      },
      ellipsis: true,
      width: "120px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.address",
      }),
      ellipsis: true,
      width: "140px",
      render(text, record) {
        return record && record.employee ? (
          <Address record={flatten(record.employee)} />
        ) : null;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.plans.weekday",
      }),
      dataIndex: "weekday",
      render(text) {
        return <Text>{text !== undefined && moment.weekdays(text)}</Text>;
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.start_time",
      }),
      dataIndex: "start_time_minutes",
      render(text) {
        return (
          <Date
            text={text && moment().startOf("day").set("minute", text)}
            format={"HH:mm"}
          />
        );
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.end_time",
      }),
      dataIndex: "end_time",
      render(text, record) {
        return (
          <Date
            text={
              record.start_time_minutes &&
              moment()
                .startOf("day")
                .set(
                  "minute",
                  record.duration_minutes + record.start_time_minutes
                )
            }
            format={"HH:mm"}
          />
        );
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.duration",
      }),
      dataIndex: "duration_minutes",
      render(text) {
        return <Text>{Math.round((text / 60) * 100) / 100}</Text>;
      },
      width: "70px",
    },
  ];
  return (
    <div>
      <Title level={5}>
        {<FormattedMessage id="app.plans.order_plan_title" />}
      </Title>

      <div>
        <Table
          rowKey={(record) => record.key}
          dataSource={sorted}
          columns={columns}
          pagination={false}
          size="small"
        />
      </div>
      <div />
    </div>
  );
};

export default Plan;
